import { CalendarBlankIcon, CalendarXIcon } from '@phosphor-icons/react'

import { CalendarPlayIcon } from '@reveni-io/reveni-ui'

import { dateStates } from './constants'

const formatDate = (dateString, language, timeZone) => {
  const formatted = new Intl.DateTimeFormat(language, { dateStyle: 'medium', timeZone }).format(new Date(dateString))
  return formatted.toUpperCase()
}

const getDateState = (startsAt, endsAt) => {
  const now = new Date()
  const startDate = startsAt ? new Date(startsAt) : null
  const endDate = endsAt ? new Date(endsAt) : null

  if (endDate && now > endDate) return dateStates.expired
  if (startDate && now < startDate) return dateStates.pending

  return dateStates.active
}

export const getDateChipInfo = ({ startsAt, endsAt, t, language = 'es', timeZone }) => {
  if (!startsAt && !endsAt) return null

  const state = getDateState(startsAt, endsAt)

  let label = ''

  if (startsAt && endsAt) {
    label = `${formatDate(startsAt, language, timeZone)} - ${formatDate(endsAt, language, timeZone)}`
  } else if (startsAt) {
    label = t('Inicio {{date}}', { date: formatDate(startsAt, language, timeZone) })
  } else {
    label = t('Fin {{date}}', { date: formatDate(endsAt, language, timeZone) })
  }

  return { label, state }
}

export const getDateChipStyles = theme => {
  return {
    [dateStates.pending]: {
      backgroundColor: theme.colors.disabled.surface,
      color: theme.colors.text.muted,
      icon: CalendarBlankIcon,
    },
    [dateStates.active]: {
      backgroundColor: theme.colors.success.surface,
      color: theme.colors.success.onSurface,
      icon: CalendarPlayIcon,
    },
    [dateStates.expired]: {
      backgroundColor: theme.colors.warning.surface,
      color: theme.colors.warning.onSurface,
      icon: CalendarXIcon,
    },
  }
}
